/**
 * Rhythmz — main entry (Butterchurn edition)
 */

import './ui/styles.css';
import { RhythmzApp } from './app';
import { el } from '@ui/dom';

async function boot(): Promise<void> {
  const canvas = el<HTMLCanvasElement>('#viz');
  const app = new RhythmzApp(canvas);
  await app.init();

  // Admin panel toggle (only visible when admin-gated)
  const adminPanel = el('#admin-panel');
  el('#admin-close').onclick = () => adminPanel.classList.remove('open');
  // Reopen via the admin badge area if needed — keyboard shortcut Ctrl+Shift+A
  window.addEventListener('keydown', (e) => {
    if (e.ctrlKey && e.shiftKey && (e.key === 'A' || e.key === 'a') && app.isAdmin) {
      adminPanel.classList.toggle('open');
    }
  });

  // Keep admin stats fresh
  setInterval(() => {
    if (app.isAdmin) {
      const fps = el('#fps').textContent;
      const source = el('#source-label').textContent;
      const adminFps = document.querySelector('#admin-fps');
      const adminSource = document.querySelector('#admin-source');
      if (adminFps) adminFps.textContent = fps || '—';
      if (adminSource) adminSource.textContent = source || '—';
    }
  }, 1000);
}

boot().catch((e) => {
  console.error('Rhythmz failed to boot:', e);
});
